module.exports = __webpack_public_path__ + "img/bull_lol3.6d0600d0.png";